import { MessagingCampaignsListItemFragment } from '@occc/graphql';

import { MessagingCampaignTabs } from './features/messaging-campaign-configure';

const MESSAGING_CENTER_BASE_URL = '/messaging-center';

export const routeCreator = {
  base: () => MESSAGING_CENTER_BASE_URL,
  campaignsList: () => `${MESSAGING_CENTER_BASE_URL}/campaigns`,
  campaignCreate: () => `${MESSAGING_CENTER_BASE_URL}/campaigns/create`,
  campaignConfigure: (campaignId: string) =>
    `${routeCreator.base()}/campaigns/${campaignId}/configure`,
  campaignConfigureWithTab: (
    campaignId: string,
    tab: MessagingCampaignTabs = MessagingCampaignTabs.Configure,
  ) => `${routeCreator.campaignConfigure(campaignId)}/${tab}`,
  campaignUpdate: (id: string) => `${MESSAGING_CENTER_BASE_URL}/campaigns/${id}/update`,
  campaignUpdateWithTab: (
    campaignId: string,
    tab: MessagingCampaignTabs = MessagingCampaignTabs.Configure,
  ) => `${routeCreator.campaignUpdate(campaignId)}/${tab}`,
  campaignDetails: (id: string) => `${MESSAGING_CENTER_BASE_URL}/campaigns/${id}`,
};

type GetMessagingCampaignTypeTitleProps = {
  channels: MessagingCampaignsListItemFragment['channelsConfig'] | null;
  joinSymbol?: string;
};

export const getMessagingCampaignTypeTitle = ({
  channels,
  joinSymbol = '/',
}: GetMessagingCampaignTypeTitleProps): string => {
  const { smsConfig, pushNotificationConfig } = channels || {};

  return (
    [smsConfig?.enabled && 'SMS', pushNotificationConfig?.enabled && 'Push']
      .filter(Boolean)
      .join(` ${joinSymbol} `) || 'N/A'
  );
};
